import { render, staticRenderFns } from "./AIModelTrain.vue?vue&type=template&id=69126800&"
import script from "./ai-model-train.js?vue&type=script&lang=js&"
export * from "./ai-model-train.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports